(() => {
  if (window.productListDrawerLegacyTriggerReady) return;
  window.productListDrawerLegacyTriggerReady = true;

  const legacySelector = '.ddrawersssOpen, .ddrawersssOpen2, #drawersssOpen';

  const getDrawer = (trigger) => {
    const controlledElement = document.getElementById(trigger.getAttribute('aria-controls'));

    if (controlledElement?.hasAttribute('data-product-list-drawer')) {
      return controlledElement;
    }

    return document.querySelector('[data-product-list-drawer]');
  };

  document.querySelectorAll(legacySelector).forEach((trigger) => {
    if (trigger.hasAttribute('aria-controls')) return;

    const drawer = getDrawer(trigger);
    if (!drawer) return;

    trigger.dataset.productListDrawerDelegated = 'true';
    trigger.setAttribute('aria-controls', drawer.id);
    trigger.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(legacySelector);
    if (!trigger) return;

    const delegated = trigger.dataset.productListDrawerDelegated === 'true';
    if (!delegated && trigger.hasAttribute('aria-controls')) return;

    const drawer = getDrawer(trigger);
    if (!drawer || typeof drawer.show !== 'function') return;

    event.preventDefault();
    trigger.dataset.productListDrawerDelegated = 'true';
    trigger.setAttribute('aria-controls', drawer.id);
    trigger.setAttribute('aria-expanded', 'false');
    drawer.show(trigger);
  });
})();
